import React from "react";
import { useDispatch } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { recalculate } from "../redux/storesSagas";

export const Recalculate = ({ isOpen, onClose, selected: { id, name }, reimport }) => {
  const dispatch = useDispatch();

  const primaryBtnHandler = () => {
    dispatch(recalculate({ id, reimport }));
    onClose();
  };

  return (
    <MainModal
      parentSelector=".stores"
      isOpen={isOpen}
      onClose={onClose}
      headerText="Recalculate"
      headerCloseHandler={onClose}
      width={400}
      height="auto"
      primaryButtonText="Ok"
      primaryBtnHandler={primaryBtnHandler}
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      containerClassName="dialog"
    >
      Are you sure to recalculate {reimport ? "and reimport" : ""}{" "}
      <span className="text-bold">{name}</span>?
    </MainModal>
  );
};
